import { render, staticRenderFns } from "./BirthdayClasswise.vue?vue&type=template&id=96385ce2&scoped=true&"
import script from "./BirthdayClasswise.vue?vue&type=script&lang=js&"
export * from "./BirthdayClasswise.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayClasswise.vue?vue&type=style&index=0&id=96385ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96385ce2",
  null
  
)

export default component.exports